<template>
  <div class="guardrail-details">
    <h5>Preprocessing Guardrails</h5>
    <div v-for="(guardrail, index) in guardrails" :key="`${index}_${guardrail.op}`" class="guardrail-content">
        <span class="guardrail-type">{{ formatGuardrailType(guardrail.op) }}</span>
        <span class="guardrail-message">{{ guardrail.message }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GuardrailDetails',
  props: {
    guardrails: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  methods: {
    formatGuardrailType(op) {
      if (!op) return ''
      return op
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ')
    }
  }
}
</script>

<style scoped>
@import '../../styles/foundations.css';

.guardrail-details {
  background-color: #ffffff;
  padding: 16px;
  color: var(--gray-500);
}

.guardrail-details h5 {
  margin-top: 0;
  font-weight: 500;
}

.guardrail-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 4px 0 4px 12px;
  margin-bottom: 8px;
  border-left: 2px solid var(--amber-400);
}

.guardrail-type {
  font-size: 12px;
  font-weight: 700;
  color: var(--gray-600);
}

.guardrail-message {
  font-size: 13px;
}
</style>
